import React, { useEffect } from 'react';
import "./Loader.css";

function Loader({ handleCloseModal = () => { }, title = "loading...", isLoaderOpen }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      handleCloseModal(); // Call your function to close the modal
    }, 1500);

    return () => clearTimeout(timer); // Clear the timer on component unmount
  }, [handleCloseModal]);

  if (!isLoaderOpen) return null;

  return (
    <>
      <div className="loader-backdrop z-10"></div>
      <div className='custom-loader'>
        <div className="loader-spinner"></div>
        {/* <p>11{title}</p> */}
      </div>
    </>
  );
}

export default Loader;
